import axiosInstance from '../constants/axiosInstance';
import publicAxiosInstance from '../constants/publicAxiosInstance';
// import { newUserInterface } from '../Interfaces/userInterface';

interface GetUsersListParams {
  name?: string;
  page?: number;
  limit?: number;
}

const getAdministrativeRoles = async (payload: any) => {
  try {
    const { data } = await axiosInstance().post(`/newUsers/getAdministrativeRoles`, payload);
    return data?.data;
  } catch (error) {
    throw error;
  }
};

const buildWorkspacePermissionTree = async (workspacePermissionTreePayload: any) => {
  try {
    const { data } = await axiosInstance().post(
      `/newUsers/buildWorkspacePermissionTree`,
      workspacePermissionTreePayload
    );
    return data?.data;
  } catch (error) {
    throw error;
  }
};

const saveUser = async (userData: any) => {
  try {
    const { data } = await axiosInstance().post(`/newUsers/saveUser`, { userData });
    return data;
  } catch (error) {
    throw error;
  }
};

const getUsersList = async ({ name = '', page = 1, limit = 50 }: GetUsersListParams = {}) => {
  try {
    const { data } = await axiosInstance().post(`/newUsers/usersList`, {
      name,
      page,
      limit,
    });
    return data.data;
  } catch (error) {
    throw error;
  }
};

const deleteUser = async (payload: any) => {
  try {
    const { data } = await axiosInstance().post(`/newUsers/deleteUser`, payload);
    return data.data;
  } catch (error) {
    throw error;
  }
};

const getUserDetails = async (userId: string) => {
  try {
    const { data } = await axiosInstance().post(`/newUsers/userDetails`, { userId });
    return data.data;
  } catch (err) {
    throw err;
  }
};

const getViewAsUserList = async (search: string) => {
  try {
    const { data } = await axiosInstance().post(`/newUsers/getViewAsUserList`, {
      query: search,
    });
    return data.data;
  } catch (error) {
    throw error;
  }
};

const createViewAsUserToken = async (viewAsUserId: string) => {
  try {
    const { data } = await axiosInstance().post(`/newUsers/createViewAsUserToken`, {
      viewAsUserId,
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};

let url = (name: any) => `/newDashboard/dashboardConfigUserListAutocomplete?nameQuery=${name}`;
const fetchUsersForEmail = async (name: null | string) => {
  try {
    const { data } = await axiosInstance().get(url(name));
    return data.data;
  } catch (err) {
    throw err;
  }
};

const getInvitedUsersList = async ({ name = '', page = 1, limit = 50 }: GetUsersListParams = {}) => {
  try {
    const { data } = await axiosInstance().post(`/newUsers/invitedUsersList`, {
      name,
      page,
      limit,
    });
    return {
      invitedUsersList: data.data?.usersList || [],
      totalPages: data.data?.totalPages,
    };
  } catch (error) {
    throw error;
  }
};

const inviteUser = async (userData: any) => {
  try {
    const { data } = await axiosInstance().post(`/newUsers/inviteUser`, { userData });
    return data;
  } catch (error) {
    throw error;
  }
};

const acceptInvite = async (activateData: { userId: string; password: string; phoneNumber: string }) => {
  try {
    const { data } = await publicAxiosInstance().post(`/newUsers/activateInvitedUserAccount`, activateData);
    return data;
  } catch (error) {
    throw error;
  }
};

export {
  getAdministrativeRoles,
  buildWorkspacePermissionTree,
  saveUser,
  getUsersList,
  deleteUser,
  getUserDetails,
  getViewAsUserList,
  createViewAsUserToken,
  fetchUsersForEmail,
  getInvitedUsersList,
  inviteUser,
  acceptInvite,
};
